module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#action",
      toString: function () {
        return this.url;
      }
    }